import { useQuery } from '@apollo/client';
import { graphql } from '../../__generated__';

export const useMHRDocumentAttachmentModal = (customerID: string, documentID: string | null | undefined, repositoryID: string | null | undefined, attachmentFileName: string | null | undefined) => {
  const { data, error, loading } = useQuery(
    graphql(`
      query mhrGetDocumentAttachment($customerID: String, $documentID: String, $repositoryID: String, $attachmentFileName: String) {
        mhrGetDocumentAttachment(customerId: $customerID, documentId: $documentID, repositoryId: $repositoryID, attachmentFileName: $attachmentFileName) {
          html
          ok
          error
          documentId
          uniqueRepositoryId
        }
      }
    `),
    {
      variables: {
        customerID,
        documentID,
        repositoryID,
        attachmentFileName
      },
    },
  );

  return {
    ok: data?.mhrGetDocumentAttachment?.ok ?? false,
    loading,
    error: error ? 'Error loading document view' : data?.mhrGetDocumentAttachment?.error,
    html: data?.mhrGetDocumentAttachment?.html,
    documentId: data?.mhrGetDocumentAttachment?.documentId,
    uniqueRepositoryId: data?.mhrGetDocumentAttachment?.uniqueRepositoryId,
  };
};
